export default function isClickInsideOneOfThoseElements(event, listOfElements) {
	const composedPath = event.composedPath();

	for (const el of listOfElements) {
		if (composedPath.includes(el)) return true;
	}

	return false;
}
